<template>
  <v-card class="v-card--flat">
    <v-dialog max-width="480" v-model="dialog" persistent>
      <PaymentStatus
        :paymentId="paymentId"
        :title="title"
        :message="message"
        :positiveBtnText="positiveBtnText"
        :negativeBtnText="negativeBtnText"
        @change="onStatusChange"
        @positive-btn-click="goToMyActivities"
        @negative-btn-click="goHome"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import PaymentStatus from '@/components/generalComponents/PaymentStatus';

export default {
  name: 'Payment',
  components: {
    PaymentStatus,
  },
  computed: {
    paymentId() {
      return this.$route.params.paymentId;
    },
    userLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
  },
  data() {
    return {
      dialog: true,
      paymentSuccess: false,

      title: this.$translate('ONE_MOMENT'),
      message: this.$translate('WAITING_PAYMENT_PROCESS'),
      negativeBtnText: '',
      positiveBtnText: '',
    };
  },
  methods: {
    onStatusChange(status) {
      this.positiveBtnText = '';
      this.negativeBtnText = '';

      if (status === 'WaitingForPayment') {
        this.title = this.$translate('ONE_MOMENT');
        this.message = this.$translate('WAITING_PAYMENT_PROCESS');
      } else if (status === 'Confirmed') {
        this.paymentSucceeded();
      } else {
        this.paymentFailed();
      }
    },
    paymentSucceeded() {
      this.title = this.$translate('PAYMENT_RECEIVED');
      this.message = this.$translate('PAYMENT_RECEIVED_DESC');

      if (this.userLoggedIn) {
        this.positiveBtnText = this.$translate('LINDA_GO_TO_APPOINTMENTS');
      }

      this.negativeBtnText = this.$translate('BACK_HOME_PAGE');

      this.$store.commit('shoppingCart/setOrders', []);
    },
    paymentFailed() {
      this.$store.commit('shoppingCart/setOrders', []);
      this.title = this.$translate('PAYMENT_FAILED');
      this.message = this.$translate('PAYMENT_FAILED_DESC');
      this.negativeBtnText = this.$translate('BACK_HOME_PAGE');
    },
    goHome() {
      this.$router.push({
        name: 'Homepage',
        params: {
          account_id: this.$store.getters.getRegion,
        },
      });
    },
    goToMyActivities() {
      this.$router.push({
        name: 'UserSettings',
        params: { myOrders: true },
      });
    },
  },
};
</script>
